import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getSettings } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Reveal } from "@/components/site/Reveal";

const CULTURE = [
  { h: "A long-term mindset", p: "We hire for people who think in years and decades, not quarters — and who take ownership of outcomes." },
  { h: "Learning by execution", p: "Responsibility is earned through disciplined work. We value depth, rigour, and the craft of operating well." },
  { h: "Ownership", p: "Our teams operate with autonomy and accountability, supported by shared standards and institutional continuity." },
];

export default function Careers() {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  return (
    <>
      <Seo title="Careers" path="/careers" settings={settings} description="Culture and opportunities at Acharya Holdings — long-term mindset, learning, and ownership." />
      <PageIntro eyebrow="Careers" title="Serious work, built to last."
        description="We build enduring businesses with people who value discipline, ownership, and the long view. If that describes how you work, we would like to hear from you." />
      <div className="surface-stone">
      <section className="container-inst py-16 lg:py-24">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {CULTURE.map((c, i) => (
            <Reveal key={c.h} delay={i * 0.05}>
              <div className="h-full rounded-[14px] border p-6" style={{ background: "var(--surface)", borderColor: "var(--card-border)" }}>
                <h3 className="text-[17px]" style={{ color: "var(--text)", fontWeight: 500 }}>{c.h}</h3>
                <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--muted)" }}>{c.p}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16">
          <SectionHeading eyebrow="Open Roles" title="Current opportunities" />
          <div data-testid="careers-open-roles-list" className="mt-8 rounded-[14px] border p-10 text-center" style={{ background: "var(--surface)", borderColor: "var(--card-border)" }}>
            <p className="text-sm" style={{ color: "var(--text)" }}>There are no open positions at this time.</p>
            <p className="mt-2 text-sm" style={{ color: "var(--muted)" }}>We welcome introductions from exceptional operators. Reach out and tell us how you work.</p>
            <Link to="/contact" className="btn btn-primary mt-6">
              Introduce Yourself
            </Link>
          </div>
        </div>
      </section>
      </div>
    </>
  );
}
